import { render, staticRenderFns } from "./mobileSurrenderCreate.vue?vue&type=template&id=8bae4a2a&scoped=true&"
import script from "./mobileSurrenderCreate.vue?vue&type=script&lang=js&"
export * from "./mobileSurrenderCreate.vue?vue&type=script&lang=js&"
import style0 from "./mobileSurrenderCreate.vue?vue&type=style&index=0&id=8bae4a2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bae4a2a",
  null
  
)

export default component.exports